// **************************************************
// Product Filter
// **************************************************

// Toggle Items

attachEvent('.product-filter__item-title', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-filter__item');
  const contentEle = parentEle.querySelector('.product-filter__item-content');
  if (contentEle) {
    parentEle.classList.toggle('is-closed');
    slideToggle(contentEle, 300, 'none');
  }
});

// Open Filter
attachEvent('.product-list__filter-trigger', 'click', (ev) => {
  const parentEle = ev.target.closest('[data-filter-parent]');
  const filterEle = parentEle.querySelector('.product-filter');
  if (filterEle) {
    filterEle.classList.add('is-open-filter');
    toggleBodyScrollLock(true);
  }
});

// Close Filter
attachEvent('.product-filter__close, .product-filter__overlay', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-filter');
  parentEle.classList.remove('is-open-filter');
  toggleBodyScrollLock(false);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const filterEle = document.querySelectorAll('.product-filter');
    filterEle.forEach((el) => {
      el.classList.remove('is-open-filter');
      toggleBodyScrollLock(false);
    });
  }
});
